<div [class]="categoryCarouselCSS()">
  <ng-container #categoryCarousel />
</div>
